import * as yup from 'yup';

export const validacaoFormImagens = yup.object().shape({
    nome: yup
        .string()
        .nullable()
        .max(60, 'O nome do aparelho deve ter no máximo 60 caracteres.')
        .required('Campo nome é obrigatório')    
         
});
